import {useCallback} from 'react';
import {useSearchParams} from 'react-router-dom';
import {MESSAGE_CREATOR_ID_QUERY_PARAM} from '@/config/routesConstants';

function useMessagingPanel() {
  const [searchParams, setSearchParams] = useSearchParams();
  const creatorId = searchParams.get(MESSAGE_CREATOR_ID_QUERY_PARAM);

  const open = useCallback(
    (id: string) => {
      setSearchParams((prev) => {
        prev.set(MESSAGE_CREATOR_ID_QUERY_PARAM, id);
        return prev;
      });
    },
    [setSearchParams]
  );

  const close = useCallback(() => {
    setSearchParams((prev) => {
      prev.delete(MESSAGE_CREATOR_ID_QUERY_PARAM);
      return prev;
    });
  }, [setSearchParams]);

  return {
    isOpen: !!creatorId,
    creatorId,
    open,
    close,
  };
}

export default useMessagingPanel;
